(function(){
  var tabs = document.querySelectorAll('#lbTabs .lb-tab');
  function filter(cat){
    document.querySelectorAll('#lbGrid .lb-pc').forEach(function(pc){
      pc.classList.toggle('lb-hide', !(cat==='all' || pc.getAttribute('data-cat')===cat));
    });
  }
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      tabs.forEach(function(x){ x.classList.remove('lb-active'); });
      this.classList.add('lb-active');
      filter(this.getAttribute('data-cat'));
    });
  });

  function toast(msg){
    var t = document.createElement('div');
    t.className = 'lb-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function(){ t.classList.add('lb-show'); }, 10);
    setTimeout(function(){
      t.classList.remove('lb-show');
      setTimeout(function(){ t.remove(); }, 350);
    }, 2400);
  }

  function bounceCart(){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.classList.remove('lb-bounce');
      void el.offsetWidth;
      el.classList.add('lb-bounce');
      setTimeout(function(){ el.classList.remove('lb-bounce'); }, 700);
    });
  }

  function addToCart(variantId, qty){
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw e; });
      return r.json();
    });
  }
  function getCart(){
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); });
  }
  function updateCartCount(){
    return getCart().then(function(cart){
      var sel = ['.cart-count','[data-cart-count]','#CartCount','.cart-item-count','.cart-link__bubble','.header__icon--cart .visually-hidden','[data-cart-item-count]'];
      sel.forEach(function(s){
        document.querySelectorAll(s).forEach(function(el){
          var oldVal = parseInt(el.textContent, 10) || 0;
          el.textContent = cart.item_count;
          if(cart.item_count > 0) el.classList.add('has-items');
          if(cart.item_count > oldVal) bounceCart();
        });
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-vid]');
    if(btn){
      e.preventDefault();
      if(btn.disabled) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';
      addToCart(parseInt(btn.getAttribute('data-add-vid'),10), 1).then(function(){
        btn.textContent = 'Added ✓';
        btn.classList.add('lb-done');
        toast('Added to bag');
        updateCartCount();
        setTimeout(function(){
          btn.textContent = originalText;
          btn.classList.remove('lb-done');
          btn.disabled = false;
        }, 1500);
      }).catch(function(err){
        btn.textContent = originalText;
        btn.disabled = false;
        toast(err && err.description ? err.description : 'Could not add — try again');
      });
      return;
    }
    var picker = e.target.closest('[data-pick-size]');
    if(picker){
      e.preventDefault();
      openSizeModal(picker.getAttribute('data-pick-size'));
    }
  });

  function openSizeModal(productId){
    var dataEl = document.getElementById('lb-vars-' + productId);
    if(!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }
    var modal = document.createElement('div');
    modal.className = 'lb-qvm lb-open';
    modal.innerHTML =
      '<div class="lb-qvm-box">' +
        '<button class="lb-qvm-x" aria-label="close">&times;</button>' +
        '<h3>Select Size</h3>' +
        '<div class="lb-qvm-sz">' +
          variants.map(function(v){
            return '<button data-vid="'+v.id+'"'+(v.available?'':' disabled')+'>'+ escapeHtml(v.title) +'</button>';
          }).join('') +
        '</div>' +
        '<button class="lb-qvm-add" disabled>Add to Bag</button>' +
      '</div>';
    document.body.appendChild(modal);
    var selectedVid = null;
    var addBtn = modal.querySelector('.lb-qvm-add');
    modal.querySelectorAll('.lb-qvm-sz button').forEach(function(b){
      b.addEventListener('click', function(){
        if(b.disabled) return;
        modal.querySelectorAll('.lb-qvm-sz button').forEach(function(x){ x.classList.remove('lb-sel'); });
        b.classList.add('lb-sel');
        selectedVid = parseInt(b.getAttribute('data-vid'), 10);
        addBtn.disabled = false;
      });
    });
    addBtn.addEventListener('click', function(){
      if(!selectedVid) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      addToCart(selectedVid, 1).then(function(){
        toast('Added to bag');
        updateCartCount();
        modal.remove();
      }).catch(function(err){
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Bag';
        toast(err && err.description ? err.description : 'Could not add');
      });
    });
    modal.querySelector('.lb-qvm-x').addEventListener('click', function(){ modal.remove(); });
    modal.addEventListener('click', function(e){ if(e.target===modal) modal.remove(); });
  }

  function escapeHtml(s){ return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartCount);
  } else {
    updateCartCount();
  }
})();

/* ===== SCROLL-REVEAL with stagger support ===== */
(function(){
  function init(){
    var els = document.querySelectorAll('section, .lb-reels-wrap, .lb-mqbar, .lb-usp, .lb-ms-cats-wrap, .lb-ms-poster, .lb-ms-grid-wrap, .lb-acc-card, .lb-cn-card');
    els.forEach(function(el){ el.classList.add('lb-reveal'); });
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('lb-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('lb-in');
          io.unobserve(e.target);
        }
      });
    }, {threshold:.05, rootMargin:'0px 0px -60px'});
    els.forEach(function(el){ io.observe(el); });

    // Stagger children inside grids
    var grids = document.querySelectorAll('.lb-ms-grid, .lb-ms-cats, .lb-grid, .lb-sb-tiles');
    grids.forEach(function(g){ g.classList.add('lb-stagger'); });
    var gridIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('lb-in');
          gridIo.unobserve(e.target);
        }
      });
    }, {threshold:.1, rootMargin:'0px 0px -40px'});
    grids.forEach(function(g){ gridIo.observe(g); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
